// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.indicatorSection .MuiGrid-root {
  flex-wrap: inherit;
}
.indicatorSection .MuiGrid-root .MuiGrid-item:last-child {
  margin-right: 0px;
}
.indicatorSection .MuiGrid-root .MuiGrid-item {
  min-width: 288px;
  text-align: left;
  height: 104px;
  padding: 14px 22px 14px 14px;
  display: flex;
  justify-content: space-between;
  border-radius: 10px;
  background: #202437;
  margin-right: 14px;
}
.indicatorSection .MuiGrid-root .MuiGrid-item .dataTitle {
  display: flex;
  width: 100%;
  font-size: 14px;
  font-family: "Poppins";
  color: rgba(255, 255, 255, 0.7);
  font-weight: 400;
  margin-top: 4px;
  gap: 4px;
  align-items: center;
}
.indicatorSection .MuiGrid-root .MuiGrid-item .dataTitle .image-wrapper {
  height: 24px;
  width: 24px;
  justify-content: center;
}
.indicatorSection .MuiGrid-root .MuiGrid-item .dataRate {
  font-size: 32px;
  font-weight: 700;
  font-family: "Poppins";
  line-height: 47.65px;
  color: #fff;
  margin: 0px 8px;
}
.indicatorSection .MuiGrid-root .MuiGrid-item .dataPerRate {
  font-size: 20px;
  font-family: "Poppins";
  font-weight: 400;
  line-height: 27.2px;
  color: rgba(255, 255, 255, 0.7);
}
.indicatorSection .MuiGrid-root .MuiGrid-item .right-image-wrapper {
  display: flex;
  align-items: center;
}
.indicatorSection .MuiGrid-root .MuiGrid-item .right-image-wrapper img {
  height: 43px;
  width: 80px;
}
.indicatorSection .MuiGrid-root .MuiGrid-item:last-child, .indicatorSection .MuiGrid-root .MuiGrid-item:nth-last-child(2) {
  min-width: 246px;
  padding: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/PerformanceIndicatorSection/styles.scss"],"names":[],"mappings":"AACM;EACI,kBAAA;AAAV;AAEU;EACI,iBAAA;AAAd;AAGU;EACI,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,4BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AADd;AAGc;EACI,aAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AADlB;AAGkB;EACI,YAAA;EACA,WAAA;EACA,uBAAA;AADtB;AAKc;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,eAAA;AAHlB;AAMc;EACI,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AAJlB;AAOc;EACE,aAAA;EACA,mBAAA;AALhB;AAMgB;EACI,YAAA;EACA,WAAA;AAJpB;AAQQ;EACI,gBAAA;EACA,aAAA;AANZ","sourcesContent":["  .indicatorSection {\r\n      .MuiGrid-root {\r\n          flex-wrap: inherit;\r\n\r\n          .MuiGrid-item:last-child {\r\n              margin-right: 0px;\r\n          }\r\n\r\n          .MuiGrid-item {\r\n              min-width: 288px;\r\n              text-align: left;\r\n              height: 104px;\r\n              padding: 14px 22px 14px 14px;\r\n              display: flex;\r\n              justify-content: space-between;\r\n              border-radius: 10px;\r\n              background: #202437;\r\n              margin-right: 14px;\r\n\r\n              .dataTitle {\r\n                  display: flex;\r\n                  width: 100%;\r\n                  font-size: 14px;\r\n                  font-family: 'Poppins';\r\n                  color: rgba(255, 255, 255, 0.7);\r\n                  font-weight: 400;\r\n                  margin-top: 4px;\r\n                  gap: 4px;\r\n                  align-items: center;\r\n\r\n                  .image-wrapper {\r\n                      height: 24px;\r\n                      width: 24px;\r\n                      justify-content: center;\r\n                  }\r\n              }\r\n\r\n              .dataRate {\r\n                  font-size: 32px;\r\n                  font-weight: 700;\r\n                  font-family: 'Poppins';\r\n                  line-height: 47.65px;\r\n                  color: #fff;\r\n                  margin: 0px 8px;\r\n              }\r\n\r\n              .dataPerRate {\r\n                  font-size: 20px;\r\n                  font-family: 'Poppins';\r\n                  font-weight: 400;\r\n                  line-height: 27.2px;\r\n                  color: rgba(255, 255, 255, 0.7);\r\n              }\r\n\r\n              .right-image-wrapper{\r\n                display: flex;\r\n                align-items: center;\r\n                img{\r\n                    height: 43px;\r\n                    width: 80px;\r\n                }\r\n              }\r\n          }\r\n        .MuiGrid-item:last-child, .MuiGrid-item:nth-last-child(2) {\r\n            min-width: 246px;\r\n            padding: 14px;\r\n        }\r\n      }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
